
export default [
    {
        path: '/manage/invoice',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '门店开支',
            keepAlive: false
        }
    },   
];
  